import { Box, Flex } from 'reflexbox';
import { useField } from 'formik';
import styled from 'styled-components';

const Emoji = styled(Box)<{ selected: boolean }>`
	font-size: 32px;
	text-align: center;
	cursor: pointer;

	opacity: ${(props) => (props.selected ? 1.0 : 0.5)};

	&:hover {
		opacity: 1;
	}
`;

function Choice(props: {
	name: string;
	emoji: string;
	index: number;
	accumulative?: boolean;
	initialValue?: number;
}) {
	const [, { value }, { setValue }] = useField(props.name);

	const actualValue = value ?? props.initialValue;

	return (
		<Emoji
			width={64}
			selected={actualValue === props.index || (!!props.accumulative && actualValue >= props.index)}
			onClick={() => setValue(props.index)}
		>
			{props.emoji}
		</Emoji>
	);
}

export default function SentimentInput(props: {
	name: string;
	suffix?: string;
	choices?: string[];
	accumulative?: boolean;
	initialValue?: number;
}) {
	const choices = props.choices ?? ['😥', '😕', '🤔', '🙂', '😃'];

	return (
		<Flex>
			{choices.map((emoji, index) => (
				<Choice
					key={emoji}
					name={props.name + '.' + (props.suffix ?? 'sentiment')}
					emoji={emoji}
					index={index}
					accumulative={props.accumulative}
					initialValue={props.initialValue}
				/>
			))}
		</Flex>
	);
}
